<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-toolbar-title>
        <span class="headline">Send Email</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click.native="hideDialog" dark>
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="card-container">
      <v-list three-line subheader class="email-template-list">
        <v-container grid-list-xl fluid class="email-template-container">
          <v-layout class="m-0" row wrap>
            <v-flex lg2>
              <v-subheader>Email Template: </v-subheader>
            </v-flex>
            <v-flex lg3>
              <v-select
                label="Select"
                :items="emailTemplateOption"
                item-value="templateCode"
                v-model="emailTemplateCode"
                hide-details
              >
                <v-autocomplete></v-autocomplete>
              </v-select>
            </v-flex>
            <v-flex lg2 v-if="assist.tool.isNotEmpty(loanAgreementPreview.src)">
              <template>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      x-large
                      slot="activator"
                      v-on="on"
                    >
                      <a target="_blank" :href="loanAgreementPreview.src">
                        <span class="material-icons">open_in_new</span>
                      </a>
                    </v-btn>
                  </template>
                  <span>Preview Loan Agreement in a New Tab</span>
                </v-tooltip>
              </template>
              <template v-if="loanAgreementSign.compressBtn || assist.tool.isNotEmpty(loanAgreementSign.compressUrl)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      x-large
                      slot="activator"
                      v-on="on"
                      @click="showSignDialog"
                      class="compress-icon"
                    >
                      <v-icon class="f-s-18" color="green">
                        mdi-arrow-expand
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Compress signature short link</span>
                </v-tooltip>
              </template>
            </v-flex>

          </v-layout>
        </v-container>
      </v-list>
      <vue-perfect-scrollbar class="scroll" :style="`height:${height}px`">
        <iframe v-if="loanAgreementPreview.isPreview" :src="loanAgreementPreview.src"></iframe>
        <v-layout v-if="ordinaryEmailPreview.isPreview" class="m-0 p-0" row wrap>
          <v-flex lg12>
            <div v-html="ordinaryEmailPreview.src"></div>
          </v-flex>
        </v-layout>
        <v-layout v-if="noaaNotificationEmailPreview.isPreview" class="m-0 p-0" row wrap>
          <v-flex lg12>
            <div v-html="noaaNotificationEmailPreview.src"></div>
          </v-flex>
        </v-layout>
        <v-layout v-show="paymentOptionPreview.isPreview" class="m-0 p-0" row wrap>
          <v-flex lg8>
            <div v-html="paymentOptionPreview.src"></div>
          </v-flex>
          <v-flex lg3 class="m-l-40">
            <v-form data-vv-scope="form">
              <div style="height: 80px">
                Communication Channel
                <v-select
                  label="Select"
                  :items="assist.systemEnum.COMMUNICATION_CHANNEL"
                  v-model="communicationChannel"
                  @change="changeEventHandler(pageEnum.CommunicationChannel)"
                  v-validate="'required'"
                  data-vv-name="notEmpty"
                  :error-messages="errors.first('form.notEmpty')"
                  hide-details
                >
                  <v-autocomplete></v-autocomplete>
                </v-select>
              </div>
              <div style="height: 80px">
                Communication Date
                <arb-date-picker-menu
                  @change="changeEventHandler(pageEnum.CommunicationDate)"
                  v-model="communicationDate"
                  v-validate="'required'"
                  data-vv-name="notEmpty"
                  :error-messages="errors.first('form.notEmpty')"
                  :hideDetails="true"
                ></arb-date-picker-menu>
              </div>
            </v-form>
          </v-flex>

        </v-layout>
      </vue-perfect-scrollbar>

    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
        <v-btn text @click.native="sendEmail" :loading="loading">Send</v-btn>
    </v-card-actions>

    <!--sign dialog-->
    <v-dialog v-model="loanAgreementSign.showDialog" persistent max-width="30%">
      <v-card>
        <v-toolbar flat>
          <span class="headline">Compress</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="hideSignDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <div v-if="loanAgreementSign.flag">
        <v-card-text>
          <v-textarea
            placeholder="Note: "
            v-model="loanAgreementSign.notes"
            outlined
            hide-details
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="compressUrl"
          >
            Next
          </v-btn>
        </v-card-actions>
        </div>
        <div v-else>
          <v-card-text>
            <span>{{ loanAgreementSign.compressUrl }}</span>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="hideSignDialog"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { OriginationBusinessApi, ProcessingApi } from '@/api/pandaria'
import { SystemEnum } from '@/assets/js/index'
import { DataType, Tool, Popup } from '@/util/index'
const tool = new Tool()
const popup = new Popup()
const pageEnum = {
  CommunicationChannel: 'channel',
  CommunicationDate: 'date'
}
export default {
  name: 'send-email-dialog',
  components: {
    VuePerfectScrollbar
  },
  props: {
    sendEmailData: Object,
    loanId: Number,
    loanPhase: Number,
    loan: Object
  },
  data () {
    return {
      fullscreen: {
        dialog: false,
        notifications: false,
        sound: true,
        widgets: false
      },
      slaveLoanOption: [{ text: 'SUBSEQUENT ADVANCE DISCLOSURES', value: 'CSL-2101' }],
      emailTemplateCode: '',
      communicationChannel: null,
      communicationDate: null,
      loanAgreementPreview: {
        isPreview: false,
        src: ''
      },
      paymentOptionPreview: {
        isPreview: false,
        src: ''
      },
      ordinaryEmailPreview: {
        isPreview: false,
        src: ''
      },
      noaaNotificationEmailPreview: {
        isPreview: false,
        src: '',
        reasonArray: [],
        reasonNote: ''
      },
      height: '0px',
      loading: false,
      assist: {
        dataType: DataType,
        systemEnum: SystemEnum,
        tool: tool
      },
      pageEnum: pageEnum,
      interval: null,
      loanAgreementSign: {
        showDialog: false,
        compressBtn: false,
        compressUrl: '',
        documentUrl: '',
        notes: '',
        flag: true
      }
    }
  },
  watch: {
    emailTemplateCode (newValue) {
      if (tool.isNotEmpty(newValue)) {
        this.previewDocument()
      }
    },
    'store.getters.getSendEmailLoanId': {
      handler: function (oldVal, newVal) {
        if (oldVal !== newVal) {
          this.loanAgreementSign.compressBtn = false
          this.loanAgreementSign.compressUrl = ''
        }
      }
    },
    deep: true,
    immediate: true
  },
  computed: {
    emailTemplateOption () {
      return tool.emailTemplateWithStatusAndRole(this.loan, this.$route.path)
      // const isPersonalRemote = this.$store.getters.getPersonalRemote
      // if (!isPersonalRemote || (isPersonalRemote && this.$store.getters.getRoleCode !== DataType.RoleEnum.ORIGINATION_AGENT.code)) {
      //   return [DataType.EmailTemplateTypeEnum.LOAN_AGREEMENT, DataType.EmailTemplateTypeEnum.PAYMENT_OPTIONS,
      //     DataType.EmailTemplateTypeEnum.LOAN_APPROVED,
      //     DataType.EmailTemplateTypeEnum.PENDING_STATUS, DataType.EmailTemplateTypeEnum.COMPLETE_LOAN_PROCESS,
      //     DataType.EmailTemplateTypeEnum.MORE_INFORMATION, DataType.EmailTemplateTypeEnum.LOAN_CANCELLATION]
      // } else {
      //   return [DataType.EmailTemplateTypeEnum.LOAN_AGREEMENT]
      // }
    }
  },
  mounted () {
    this.height = window.screen.availHeight * 0.8 + 'px'
  },
  methods: {
    hideDialog () {
      this.loading = false
      this.clearPreview()
      this.emailTemplateCode = ''
      this.$emit('hideDialog', 'SEND_EMAIL')
    },
    async previewSimpleTemplate (emailTemplateCode) {
      const input = {
        loanId: this.loanId,
        templateCode: emailTemplateCode
      }
      await OriginationBusinessApi.previewEmail(input, this.previewNotificationCallback, this.previewEmailFailure)
    },
    async sendSimpleTemplate (pathCode) {
      const input = {
        loanId: this.loanId,
        pathCode: pathCode
      }
      await OriginationBusinessApi.sendEmail(input, this.sendEmailCallback, this.sendEmailFailure)
    },
    previewDocument () {
      const emailTemplateCode = this.emailTemplateCode
      this.clearPreview()
      switch (emailTemplateCode) {
        case ' ':
          if (this.store.getters.getHasPaymentSchedule) {
            this.previewLoanAgreement()
          } else {
            popup.popupForInfo('There is not payment schedule data')
          }
          break
        case 'CSL-2101':
          if (this.store.getters.getHasPaymentSchedule) {
            this.previewEmailForSlaveLoan()
          } else {
            popup.popupForInfo('There is not payment schedule data')
          }
          break
        default:
          this.previewSimpleTemplate(emailTemplateCode)
          break
      }
      // switch (this.loanPhase) {
      //   case DataType.LoanPhaseEnum.LOAN_ORIGINATION.value:
      //     switch (emailTemplateCode) {
      //       case DataType.EmailTemplateTypeEnum.LOAN_AGREEMENT.value:
      //         if (this.store.getters.getHasPaymentSchedule) {
      //           this.previewLoanAgreement()
      //         } else {
      //           popup.popupForInfo('There is not payment schedule data')
      //         }
      //         break
      //       case DataType.EmailTemplateTypeEnum.PAYMENT_OPTIONS.value:
      //         this.previewPaymentOptionEmail()
      //         break
      //       case DataType.EmailTemplateTypeEnum.LOAN_APPROVED.value:
      //         this.previewOrdinaryNotificationEmail(DataType.EmailTemplateTypeEnum.LOAN_APPROVED.templateCode)
      //         break
      //       case DataType.EmailTemplateTypeEnum.PENDING_STATUS.value:
      //         this.previewOrdinaryNotificationEmail(DataType.EmailTemplateTypeEnum.PENDING_STATUS.templateCode)
      //         break
      //       case DataType.EmailTemplateTypeEnum.COMPLETE_LOAN_PROCESS.value:
      //         this.previewOrdinaryNotificationEmail(DataType.EmailTemplateTypeEnum.COMPLETE_LOAN_PROCESS.templateCode)
      //         break
      //       case DataType.EmailTemplateTypeEnum.MORE_INFORMATION.value:
      //         this.previewOrdinaryNotificationEmail(DataType.EmailTemplateTypeEnum.MORE_INFORMATION.templateCode)
      //         break
      //       case DataType.EmailTemplateTypeEnum.LOAN_CANCELLATION.value:
      //         this.previewOrdinaryNotificationEmail(DataType.EmailTemplateTypeEnum.LOAN_CANCELLATION.templateCode)
      //         break
      //       default:
      //         break
      //     }
      //     break
      //   case DataType.LoanPhaseEnum.PAYMENT_PROCESSING.value:
      //     if (this.store.getters.getHasPaymentSchedule) {
      //       this.previewEmailForSlaveLoan()
      //     } else {
      //       popup.popupForInfo('There is not payment schedule data')
      //     }
      //     break
      // }
    },
    sendEmail () {
      this.loading = true
      if (tool.isEmpty(this.emailTemplateCode)) {
        popup.popupForWarning('Please choose email template')
      } else {
        const emailTemplateCode = this.emailTemplateCode
        switch (emailTemplateCode) {
          case ' ':
            this.sendLoanAgreement()
            break
          case 'CSL-2101':
            this.sendEmailForSlaveLoan()
            break
          default: {
            let pathCode = ''
            const emailTemplateEnum = SystemEnum.EMAIL_TEMPLATE_ENUM
            for (const item in emailTemplateEnum) {
              if (emailTemplateEnum[item].templateCode === emailTemplateCode) {
                pathCode = emailTemplateEnum[item].pathCode
              }
            }
            if (tool.isNotEmpty(pathCode)) {
              this.sendSimpleTemplate(pathCode)
            }
            break
          }
        }
        // switch (this.loanPhase) {
        //   case DataType.LoanPhaseEnum.LOAN_ORIGINATION.value:
        //     switch (emailTemplateCode) {
        //       case DataType.EmailTemplateTypeEnum.LOAN_AGREEMENT.value:
        //         this.sendLoanAgreement()
        //         break
        //       case DataType.EmailTemplateTypeEnum.PAYMENT_OPTIONS.value:
        //         this.$validator.validateAll('form').then(res => {
        //           if (res) {
        //             this.sendPaymentOptionEmail()
        //           } else {
        //             popup.popupForWarning('Please input completely.')
        //             this.loading = false
        //           }
        //         })
        //         break
        //       // case DataType.EmailTemplateTypeEnum.NOAA_NOTIFICATION.value:
        //       //   if (tool.isEmpty(this.noaaNotificationEmailPreview.reasonArray)) {
        //       //     popup.popupForWarning('Please select a reason.')
        //       //     this.loading = false
        //       //   } else {
        //       //     this.sendNotification(DataType.EmailTemplateTypeEnum.NOAA_NOTIFICATION.templateCode)
        //       //   }
        //       //   break
        //       case DataType.EmailTemplateTypeEnum.LOAN_APPROVED.value:
        //         this.sendNotification(DataType.EmailTemplateTypeEnum.LOAN_APPROVED.templateCode)
        //         break
        //       case DataType.EmailTemplateTypeEnum.PENDING_STATUS.value:
        //         this.sendNotification(DataType.EmailTemplateTypeEnum.PENDING_STATUS.templateCode)
        //         break
        //       case DataType.EmailTemplateTypeEnum.COMPLETE_LOAN_PROCESS.value:
        //         this.sendNotification(DataType.EmailTemplateTypeEnum.COMPLETE_LOAN_PROCESS.templateCode)
        //         break
        //       case DataType.EmailTemplateTypeEnum.MORE_INFORMATION.value:
        //         this.sendNotification(DataType.EmailTemplateTypeEnum.MORE_INFORMATION.templateCode)
        //         break
        //       case DataType.EmailTemplateTypeEnum.LOAN_CANCELLATION.value:
        //         this.sendNotification(DataType.EmailTemplateTypeEnum.LOAN_CANCELLATION.templateCode)
        //         break
        //       default:
        //         break
        //     }
        //     break
        //   case DataType.LoanPhaseEnum.PAYMENT_PROCESSING.value:
        //     this.sendEmailForSlaveLoan()
        //     break
        // }
      }
    },
    async previewLoanAgreement () {
      await OriginationBusinessApi.previewLoanAgreement(this.loanId, this.previewEmailCallback, function (error) {
        popup.popupForError(error?.data?.message)
      })
    },
    async sendLoanAgreement () {
      const $this = this
      const sendRequest = {
        loanId: $this.loanId,
        notificationType: DataType.NotificationTypeEnum.SES_MESSAGE.value
      }
      await OriginationBusinessApi.sendLoanAgreement(sendRequest, function (result) {
        $this.sendLoanAgreementCallback(result)
      }, this.sendEmailFailure)
    },
    async previewPaymentOptionEmail () {
      const input = {
        loanId: this.loanId,
        pathCode: DataType.EmailTemplateTypeEnum.PAYMENT_OPTIONS.templateCode
      }
      await OriginationBusinessApi.previewPaymentOptionEmail(input, this.previewEPOCallback, this.previewEmailFailure)
    },
    async previewOrdinaryNotificationEmail (pathCodeValue) {
      const input = {
        loanId: this.loanId,
        pathCode: pathCodeValue
      }
      await OriginationBusinessApi.previewOrdinaryNotificationEmail(input, this.previewNotificationCallback, this.previewEmailFailure)
    },
    async sendPaymentOptionEmail () {
      const input = {
        loanId: this.loanId,
        pathCode: DataType.EmailTemplateTypeEnum.PAYMENT_OPTIONS.templateCode,
        languageCode: this.$store.getters.getLanguageCode,
        communicationChannel: this.communicationChannel,
        communicationDate: this.communicationDate
      }
      await OriginationBusinessApi.sendPaymentOptionEmail(input, this.sendEmailCallback, this.sendEmailFailure)
    },
    async sendNotification (pathCode) {
      const input = {
        loanId: this.loanId,
        pathCode: pathCode,
        languageCode: this.$store.getters.getLanguageCode
      }
      if (this.emailTemplateCode === DataType.EmailTemplateTypeEnum.NOAA_NOTIFICATION.value) {
        input.data = {
          reasonArray: this.noaaNotificationEmailPreview.reasonArray,
          reasonNote: this.noaaNotificationEmailPreview.reasonNote
        }
      }
      await OriginationBusinessApi.sendNotification(input, this.sendEmailCallback, this.sendEmailFailure)
      // 解决同一界面，第二次发送会记录上一次发送原因
      this.noaaNotificationEmailPreview.reasonArray = []
      this.noaaNotificationEmailPreview.reasonNote = ''
    },
    async previewEmailForSlaveLoan () {
      await ProcessingApi.previewEmailBySlaveLoan({ loanId: this.store.getters.getPPSFirstValidSlaveLoanId }, this.previewEmailCallback, this.previewEmailFailure)
    },
    async sendEmailForSlaveLoan () {
      const input = { loanId: this.store.getters.getPPSFirstValidSlaveLoanId }
      await ProcessingApi.sendEmailForSlaveLoan(input, this.sendEmailCallback, this.sendEmailFailure)
    },
    previewNotificationCallback (result) {
      const $this = this
      if (tool.isNotEmpty(result)) {
        if (this.emailTemplateCode === DataType.EmailTemplateTypeEnum.NOAA_NOTIFICATION.value) {
          $this.noaaNotificationEmailPreview.isPreview = true
          $this.noaaNotificationEmailPreview.src = result.content
          $this.$nextTick(res => {
            const element = document.getElementsByClassName('reason-option')
            for (let i = 0; i < element.length; i++) {
              const itemEle = element[i]
              itemEle.removeAttribute('disabled')
              // 绑定CheckBox的点击事件
              itemEle.addEventListener('click', function () {
                const reasonCode = this.getAttribute('data-key')
                if ($this.noaaNotificationEmailPreview.reasonArray.includes(reasonCode)) {
                  tool.removeKey($this.noaaNotificationEmailPreview.reasonArray, reasonCode)
                } else {
                  $this.noaaNotificationEmailPreview.reasonArray.push(reasonCode)
                }

                if (reasonCode === '1022') {
                  if (document.getElementById('manualFilledContent').hasAttribute('disabled')) {
                    document.getElementById('manualFilledContent').removeAttribute('disabled')
                  } else {
                    document.getElementById('manualFilledContent').setAttribute('disabled', 'true')
                  }
                }
              })
            }

            document.getElementById('manualFilledContent').addEventListener('blur', function () {
              $this.noaaNotificationEmailPreview.reasonNote = this.value
            })
          })
        } else {
          $this.ordinaryEmailPreview.isPreview = true
          $this.ordinaryEmailPreview.src = result.content
        }
      }
    },
    previewEPOCallback (result) {
      const $this = this
      if (tool.isNotEmpty(result)) {
        this.paymentOptionPreview.isPreview = true
        this.paymentOptionPreview.src = result.content
        this.interval = setInterval(function () {
          const communicationChannel = document.getElementById('communicationChannel')
          const communicationDate = document.getElementById('communicationDate')
          if (tool.isNotNull(communicationChannel) && tool.isNotNull(communicationDate)) {
            communicationChannel.innerText = '[Communication Channel]'
            communicationDate.innerText = '[Communication Date]'
            clearInterval($this.interval)
            $this.interval = null
          }
        }, 100)
      }
    },
    previewEmailCallback (result) {
      this.loading = false
      this.loanAgreementPreview.isPreview = true
      this.loanAgreementPreview.src = result.documentUrl
    },
    previewEmailFailure (err) {
      popup.popupForError(err.message)
    },
    sendLoanAgreementCallback (data) {
      const _this = this
      popup.popupForSuccess('Success to send email to customer')
      _this.$eventBus.$emit('updateSignStatus', DataType.SignStatusEnum.NOT_SIGNED)
      if (this.emailTemplateCode !== ' ') {
        _this.hideDialog()
      } else {
        if (tool.isNotEmpty(data)) {
          _this.loanAgreementSign.documentUrl = data.documentUrl
        }
        _this.loanAgreementSign.compressBtn = true
        _this.loading = false
        _this.loanAgreementSign.flag = true
      }
    },
    sendEmailCallback (data) {
      const _this = this
      popup.popupForSuccess('Success to send email to customer')
      if (_this.emailTemplateCode === DataType.EmailTemplateTypeEnum.LOAN_AGREEMENT.value) {
        _this.$eventBus.$emit('updateSignStatus', DataType.SignStatusEnum.NOT_SIGNED)
      }
      if (this.emailTemplateCode === 'CSL-2101') {
        if (tool.isNotEmpty(data)) {
          _this.loanAgreementSign.documentUrl = data.documentUrl
        }
        _this.loanAgreementSign.compressBtn = true
        _this.loading = false
        _this.loanAgreementSign.flag = true
      } else {
        this.hideDialog()
      }
    },
    sendEmailFailure (err) {
      popup.popupForError(err.message)
      this.hideDialog()
    },
    changeEventHandler (type) {
      switch (type) {
        case pageEnum.CommunicationChannel:
          if (tool.isNotNull(document.getElementById('communicationChannel'))) {
            document.getElementById('communicationChannel').innerText = this.communicationChannel
          }
          break
        case pageEnum.CommunicationDate:
          if (tool.isNotNull(document.getElementById('communicationDate'))) {
            document.getElementById('communicationDate').innerText = this.communicationDate
          }
          break
      }
    },
    clearPreview () {
      this.loanAgreementPreview.isPreview = false
      this.loanAgreementPreview.src = ''
      this.paymentOptionPreview.isPreview = false
      this.paymentOptionPreview.src = ''
      this.ordinaryEmailPreview.isPreview = false
      this.ordinaryEmailPreview.src = ''
      this.noaaNotificationEmailPreview.isPreview = false
      this.noaaNotificationEmailPreview.src = ''
      this.communicationDate = null
      this.communicationChannel = null
    },
    showSignDialog () {
      this.loanAgreementSign.showDialog = true
    },
    hideSignDialog () {
      this.loanAgreementSign.showDialog = false
    },
    compressUrl () {
      const _this = this
      if (tool.isEmpty(_this.loanAgreementSign.documentUrl)) {
        return popup.popupForError()
      }
      if (tool.isEmpty(_this.loanAgreementSign.notes)) {
        return popup.popupForWarning('Please add a note')
      }
      const input = {
        loanId: _this.loan.id,
        noteContent: _this.loanAgreementSign.notes,
        signatureLink: _this.loanAgreementSign.documentUrl,
        loanNo: _this.loan.loanNo
      }
      OriginationBusinessApi.compressSignatureLink(input, function (result) {
        _this.loanAgreementSign.compressUrl = result
        _this.loanAgreementSign.flag = false
        _this.loanAgreementSign.notes = ''
        _this.$eventBus.$emit('judgeCompressEvent', true)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  .scroll {
    height: calc(100vh - 320px);
    width: 100%;
    iframe, div {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
  padding-bottom: 0 !important;
  .email-template-list {
    padding-bottom: 0;
    .email-template-container {
      padding-bottom: 0;
    }
  }
}
.compress-icon {
  padding-bottom: 3px;
}
</style>
